import { render, staticRenderFns } from "./MessageRow.vue?vue&type=template&id=316e5d78&scoped=true"
import script from "./MessageRow.vue?vue&type=script&lang=js"
export * from "./MessageRow.vue?vue&type=script&lang=js"
import style0 from "./MessageRow.vue?vue&type=style&index=0&id=316e5d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316e5d78",
  null
  
)

export default component.exports